import React from 'react';
import StaffsProvider from './staffs-provider';

export default function withStaffs(WrappedComponent) {
  return function StaffsProviderHOC(props) {
    return (
      <StaffsProvider>
          <WrappedComponent {...props} />
      </StaffsProvider>
    );
  };
};
